export enum QaQcTestResultEnum {
    TEST_RESULT = 'TEST RESULT',
}